import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { logger } from '@/lib/logger';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';

interface SimpleProtectedRouteProps {
  children: React.ReactNode;
  requiredLevel?: 'none' | 'member' | 'admin' | 'super_admin';
}

const SimpleProtectedRoute: React.FC<SimpleProtectedRouteProps> = ({ children, requiredLevel = 'member' }) => {
  const { user, isLoading, isAdmin, isMember, isInitialized } = useAuth();
  
  // Show loading state while auth is initializing
  if (isLoading || !isInitialized) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
        <NavBar />
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
        <Footer />
      </div>
    );
  }

  // Log auth state for debugging
  logger.info('SimpleProtectedRoute - requiredLevel:', requiredLevel, 'isLoading:', isLoading, 'isInitialized:', isInitialized, 'user:', user?.email, 'isMember:', isMember, 'isAdmin:', isAdmin);

  // Check access based on required level
  if (requiredLevel === 'admin' && !isAdmin) {
    return <Navigate to="/member-access" replace />;
  }
  
  if (requiredLevel === 'member' && !isMember) {
    return <Navigate to="/member-access" replace />;
  }

  // User has access, render the children
  return <>{children}</>;
};

export default SimpleProtectedRoute;